import {
    headingForm,
    headingInitialValues,
    headingValidation,
} from '../../../catalyst/core/form/Heading/schema';
import {
    paragraphForm,
    paragraphInitialValues,
    paragraphValidation,
} from '../../../catalyst/core/form/Paragraph/schema';
import {
    textFieldForm,
    textFieldInitialValues,
    textFieldValidation,
} from '../../../catalyst/core/form/TextField/schema';
import {
    numberFieldForm,
    numberFieldInitialValues,
    numberFieldValidation,
} from '../../../catalyst/core/form/NumberField/schema';
import {
    selectFieldForm,
    selectFieldInitialValues,
    selectFieldValidation,
} from '../../../catalyst/core/form/Select/schema';
import {
    checkboxForm,
    checkboxInitialValues,
    checkboxValidation,
} from '../../../catalyst/core/form/Checkbox/schema';
import {
    dateFieldForm,
    dateFieldInitialValues,
    dateFieldValidation,
} from '../../../catalyst/core/form/DateField/schema';

const tools = {
    1: {
        id: 1,
        toolId: 1,
        label: 'Heading',
        component: 'Heading',
        form: headingForm,
        validationSchema: headingValidation,
        values: headingInitialValues,
    },
    2: {
        id: 2,
        toolId: 2,
        label: 'Paragraph',
        component: 'Paragraph',
        form: paragraphForm,
        validationSchema: paragraphValidation,
        values: paragraphInitialValues,
    },
    3: {
        id: 3,
        toolId: 3,
        label: 'Line Break',
        component: 'Divider',
    },
    4: {
        id: 4,
        toolId: 4,
        label: 'Text Field',
        type: 'text',
        component: 'FormikTextField',
        form: textFieldForm,
        validationSchema: textFieldValidation,
        values: textFieldInitialValues,
    },
    5: {
        id: 5,
        toolId: 5,
        label: 'Number Field',
        type: 'number',
        component: 'FormikTextField',
        form: numberFieldForm,
        validationSchema: numberFieldValidation,
        values: numberFieldInitialValues,
    },
    6: {
        id: 6,
        toolId: 6,
        label: 'DropDown',
        component: 'FormikSelect',
        form: selectFieldForm,
        validationSchema: selectFieldValidation,
        values: selectFieldInitialValues,
    },
    7: {
        id: 7,
        toolId: 7,
        label: 'Checkbox',
        component: 'FormikCheckbox',
        form: checkboxForm,
        validationSchema: checkboxValidation,
        values: checkboxInitialValues,
    },
    8: {
        id: 8,
        toolId: 8,
        label: 'Date Selector',
        component: 'FormikDateField',
        form: dateFieldForm,
        validationSchema: dateFieldValidation,
        values: dateFieldInitialValues,
    },
};

export default tools;
